import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';

export const TeamSection = () => {
  const team = [
    {
      name: 'Bruno Velloso',
      role: 'Co-fundador e Presidente da União Confraria',
      image: 'https://customer-assets.emergentagent.com/job_6b64d89c-5fb6-4989-a00f-bea76b519dd7/artifacts/44o0idnb_image.png',
      description: 'Estrategista e mentor da comunidade Web3'
    },
    {
      name: 'Juliano Kimura',
      role: 'Fundador e Idealizador',
      image: 'https://customer-assets.emergentagent.com/job_6b64d89c-5fb6-4989-a00f-bea76b519dd7/artifacts/9q11a5od_2a5bfe2d6f815c88a936a8d2a18d35eee8250ae8.png',
      description: 'Visionário da Web3 e líder da transformação descentralizada'
    }
  ];

  return (
    <section id="team" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            <span className="gradient-text">Conheça a Equipe</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base sm:text-lg">
            Líderes visionários construindo o futuro da Web3
          </p>
        </motion.div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Card className="glass-strong p-6 text-center hover:glow-primary transition-all duration-300 group">
                {/* Image */}
                <div className="relative w-32 h-32 mx-auto mb-4">
                  <div className="absolute inset-0 bg-gradient-primary rounded-full opacity-0 group-hover:opacity-20 transition-opacity blur-xl" />
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full rounded-full object-cover border-2 border-primary/30 group-hover:border-primary transition-colors"
                  />
                </div>

                {/* Info */}
                <h3 className="text-xl font-bold mb-2">{member.name}</h3>
                <Badge className="mb-3 bg-primary/10 text-primary border-primary/30">
                  {member.role}
                </Badge>
                <p className="text-sm text-muted-foreground mb-4">{member.description}</p>

                {/* Social Link */}
                <button 
                  onClick={() => window.open('https://ai.eco.br/plans/1956939?bundle_token=98b0c0c2a2973b00d7c39ae8a2114a1a&utm_source=manual', '_blank')}
                  className="inline-flex items-center gap-2 text-sm text-primary hover:text-primary-glow transition-colors"
                >
                  <span>Conectar</span>
                  <ArrowRight className="h-4 w-4" />
                </button>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;